import PathwaysRouter from './PathwaysRouter';

export default PathwaysRouter;
